module.exports = __webpack_public_path__ + "static/media/lotterybox.b978a3d7.png";